import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { UsagePage } from '../screens/admin/UsagePage';
import { periodSearch } from '../screens/admin/period-search';

const searchSchema = z.object({
  ...periodSearch,
  /** The bar that was opened: a feature's companies, or a screen's. */
  feature: z.string().optional(),
  screen: z.string().optional(),
});

export const Route = createFileRoute('/admin/usage')({
  validateSearch: searchSchema,
  component: UsagePage,
});
